module.exports = __webpack_public_path__ + "static/media/1.371dc5c6.png";